<template>
<div class="about-area">
   <div class="container">
            <!-- Trending Tittle -->
            <div class="row">
               <div class="col-lg-12">
                     <div class="trending-tittle">
                     </div>
               </div>
            </div>
            <div class="row">
               <div class="col-lg-8">
                     <!-- Trending Tittle -->
                           <div class="about-right mb-90">
                                 <div class="section-tittle mb-30 pt-30">
                                    <h3 style="text-align: center;">NGUYÊN TẮC ĐẤU GIÁ TRỰC TUYẾN</h3>
                                 </div>
                                 <div class="about-prea" style="text-align: justify;">
                                    <p class="about-pera1">Đấu giá trực tuyến là một trong những hình thức đấu giá được quy định tại khoản 1 Điều 40 Luật đấu giá tài sản. Do đó, để tổ chức cuộc đấu giá tài sản bằng hình thức đấu giá trực tuyến, trước hết, Công ty đấu giá Hợp danh Số 5 – Quốc gia phải tuân thủ các nguyên tắc quy định tại Điều 6 Luật đấu giá tài sản:</p>
                                    <p class="about-pera1">1. Tuân thủ quy định của pháp luật.</p>
                                    <p class="about-pera1">2. Bảo đảm tính độc lập, trung thực, công khai, minh bạch, công bằng, khách quan.</p>
                                    <p class="about-pera1">3. Bảo vệ quyền, lợi ích hợp pháp của người có tài sản đấu giá, người tham gia đấu giá, người trúng đấu giá, người mua được tài sản đấu giá, tổ chức đấu giá tài sản, đấu giá viên.</p>
                                    <p class="about-pera1">4. Cuộc đấu giá phải do đấu giá viên điều hành, trừ trường hợp cuộc đấu giá do Hội đồng đấu giá tài sản thực hiện.</p>
                                    <p class="about-pera1">Bên cạnh những nguyên tắc chung về đấu giá tài sản, để tổ chức cuộc đấu giá tài sản bằng hình thức đấu giá trực tuyến, Công ty đấu giá Hợp danh Số 5 – Quốc gia còn đảm bảo tuân thủ các nguyên tắc đấu giá trực tuyến được quy định tại Điều 8 Nghị định 62/2017/NĐ-CP:</p>
                                    <p class="about-pera1">1. Tuân thủ quy định của pháp luật về đấu giá tài sản.</p>
                                    <p class="about-pera1">2. Bảo mật về tài khoản truy cập, thông tin về người tham gia đấu giá và các thông tin khác theo quy định của pháp luật.</p>
                                    <p class="about-pera1">3. Bảo đảm tính khách quan, minh bạch, an toàn, an ninh mạng.</p>
                                    <p class="about-pera1">4. Bảo vệ quyền và lợi ích hợp pháp của người có tài sản, người tham gia đấu giá và cá nhân, tổ chức có liên quan.</p>
                                    <p class="about-pera1">Công ty Đấu giá Hợp danh Số 5 – Quốc gia cam kết thực hiện đúng và đầy đủ các quy định của pháp luật về nguyên tắc đấu giá tài sản bằng hình thức trực tuyến. Với bề dày kinh nghiệm và uy tín đã được tích lũy trong thời gian qua, chúng tôi tin tưởng sẽ luôn đồng hành cùng khách hàng để vượt qua khó khăn, nắm bắt cơ hội để cùng nhau xây dựng một thị trường đấu giá tài sản công khai, minh bạch và phát triển bền vững.</p>
                                    <p class="about-pera1">Trân trọng./.</p>

                                 </div>
                           </div>
               </div>
               <div class="col-lg-4">
               </div>
            </div>
   </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
export default {
  name: 'About',
  mixins: [mixin],
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/News/2.vue